import React from "react";
import logo from "../../assets/images/logoN.png";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import MailOutlineOutlinedIcon from "@mui/icons-material/MailOutlineOutlined";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import { Link, useNavigate } from "react-router-dom";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import Hamburger from "hamburger-react";

const Navbar = () => {
  const brands = [
    "Kato",
    "Tadano",
    "Sany",
    "Sumitomo",
    "Liebherr",
    "Zoomlion",
    "Terex",
    "Xcmg",
  ];

  const [isOpen, setOpen] = React.useState(false);

  const [dropdown, setDropdown] = React.useState(false);
  const toggleDropdown = () => {
    setDropdown((prevState) => !prevState);
  };

  const [dropdownLog, setDropdownLog] = React.useState(false);
  const toggleDropdownLog = () => {
    setDropdownLog((prevState) => !prevState);
  };

  const [navbarActive, setNavbarActive] = React.useState(false);
  const handleNavbar = () => {
    setNavbarActive((prevState) => !prevState);
  };
  const [userName, setUserName] = React.useState(null);
  React.useEffect(() => {
    const token = window.localStorage.getItem("Fttoken");
    const user = window.localStorage.getItem("FtuserName");

    if (token && user) {
      setUserName(user);
    }
  }, []);

  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("Fttoken");
    localStorage.removeItem("FtIsLoggedIn");
    localStorage.removeItem("FtuserName");
    setUserName(null);
    navigate("/productlists");
  };

  return (
    <div className="navigation">
      <div className="nav-header bgLog py-3 px-5 text-center text-[13px] text-white">
        Find the best construction machinery for rent or purchase—premium
        equipment, competitive rates, and fast delivery across the UAE
      </div>

      <div className="nav-title pt-7 pb-7">
        <div className="container flex justify-between items-center ">
          <div className="nav-logo">
            <img src={logo} alt="AGA Logo" />
          </div>

          <div className="nav-info flex gap-14">
            <div className="nav-call show-nav-item gap-4">
              <div className="nav-icon">
                <CallOutlinedIcon sx={{ fontSize: "22px" }} />
              </div>
              <div className="nav-content">
                <span>For Rent</span>
                <a href="tel:+971501381984">+971 50 138 1984</a>
              </div>
            </div>

            <div className="nav-call show-nav-item gap-4">
              <div className="nav-icon">
                <CallOutlinedIcon sx={{ fontSize: "22px" }} />
              </div>
              <div className="nav-content">
                <span>For Buy & Sale</span>
                <a href="tel:+971501501145">+971 50 150 1145</a>
              </div>
            </div>

            <div className="nav-call show-nav-item gap-4">
              <div className="nav-icon">
                <MailOutlineOutlinedIcon sx={{ fontSize: "22px" }} />
              </div>
              <div className="nav-content">
                <span>Email Us</span>
                <a href="mailto:info@agacrane.com">info@agacrane.com</a>
              </div>
            </div>

            <Link to="/contact-us" className="btn-quote btn-quote-white">
              Request a Quote
            </Link>

            <button className="show-item btn-nav-ham" onClick={handleNavbar}>
              <Hamburger toggled={isOpen} toggle={setOpen} />
            </button>
          </div>
        </div>
      </div>

      <div className={`nav-links ${navbarActive ? "active" : "notactive"}`}>
        <div className="container flex justify-between items-center">
          <div className="nav-link-left">
            <Link to="/">Home</Link>
            <Link to="/about-us">About Us</Link>
            <Link to="#" className="dropdown relative" onClick={toggleDropdown}>
              Rental and Sales Inventory{" "}
              <ExpandMoreOutlinedIcon sx={{ fontSize: "18px" }} />
              <ul
                className={`dropdown-menu shadow-xl ${
                  dropdown ? "active" : "notactive"
                }`}
              >
                {brands.map((brand, index) => (
                  <Link to={`/productlists/?${brand}`} key={index}>
                    {brand}
                  </Link>
                ))}
              </ul>
            </Link>
            <Link to="/organizational-chart">Organization Chart</Link>
            <Link to="/services">Services</Link>
            <Link to="/contact-us">Contact Us</Link>
          </div>

          <div className="nav-link-right">
            {userName ? (
              <Link
                to="#"
                className="dropdown relative text-[#F84E59]"
                onClick={toggleDropdownLog}
              >
                Welcome, {userName}
                <ExpandMoreOutlinedIcon sx={{ fontSize: "18px" }} />
                <ul
                  className={`dropdown-menu shadow-xl ${
                    dropdownLog ? "active" : "notactive"
                  }`}
                >
                  <button onClick={handleLogout}>
                    <LogoutOutlinedIcon
                      sx={{ fontSize: "20px", marginRight: "15px" }}
                    />
                    Logout
                  </button>
                </ul>
              </Link>
            ) : (
              <Link to="/login">
                <AccountCircleOutlinedIcon sx={{ marginRight: "6px" }} />
                Login
              </Link>
            )}
          </div>

          <div className="nav-info show-item gap-5 nav-info-mobile">
            <div className="nav-call show-item gap-4">
              <div className="nav-icon">
                <CallOutlinedIcon sx={{ fontSize: "22px" }} />
              </div>
              <div className="nav-content">
                <span>For Rent</span>
                <a href="tel:+971501381984">+971 50 138 1984</a>
              </div>
            </div>

            <div className="nav-call show-item gap-4">
              <div className="nav-icon">
                <CallOutlinedIcon sx={{ fontSize: "22px" }} />
              </div>
              <div className="nav-content">
                <span>For Buy & Sale</span>
                <a href="tel:+971501501145">+971 50 150 1145</a>
              </div>
            </div>

            <div className="nav-call show-item gap-4">
              <div className="nav-icon">
                <MailOutlineOutlinedIcon sx={{ fontSize: "22px" }} />
              </div>
              <div className="nav-content">
                <span>Email Us</span>
                <a href="mailto:info@agacrane.com">info@agacrane.com</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
